import { IntranetSuggestResponse } from "./intranetSearch/models/intranet-search";

export const peopleResponseMockRu: IntranetSuggestResponse = {
    "people": {
        "result": [
            {
                "url": "https://staff.yandex-team.ru/jeltukhin",
                "click_urls": [
                    "//clck.yandex.ru/click/dtype=SAAS/p=0/saas_url=https%3A%2F%2Fstaff.yandex-team.ru%2Fjeltukhin/robot=0/r=%25D0%2596%25D0%25B5%25D0%25BB%25D1%2582%25D1%2583%25D1%2585%25D0%25B8%25D0%25BD/service=intrasearch-people/kps=78408/uid=is1120000000834105/yandexuid=is1120000000834105/reqid=1736513964647383-486734910552747836-saas-searchproxy-stable-vla-18-SAAS-intrasearch-people/raId=BEFADCEBDF60A2C7/slots=/how=rlv/*data=url%3Dhttps%3A%2F%2Fstaff.yandex-team.ru%2Fjeltukhin"
                ],
                "layer": "people",
                "id": "jeltukhin",
                "title": "Дмитрий Желтухин",
                "staff_id": 460300,
                "uid": "1120000000762953",
                "login": "jeltukhin",
                "name": {
                    "first": "Дмитрий",
                    "last": "Желтухин",
                    "middle": ""
                },
                "is_dismissed": false,
                "affiliation": "external",
                "is_robot": false,
                "is_memorial": false,
                "staff_agreement": true,
                "phone": null,
                "telegram": [
                    "JeltukhinDmitry"
                ],
                "position": "Специалист",
                "department_name": "Группа Кассиопея. ОКД (Поддержка бизнеса)",
                "gaps": [],
                "gap": null,
                "cars": [],
                "bicycles": []
            },
            {
                "url": "https://staff.yandex-team.ru/zheltukhina-o",
                "click_urls": [
                    "//clck.yandex.ru/click/dtype=SAAS/p=0/saas_url=https%3A%2F%2Fstaff.yandex-team.ru%2Fzheltukhina-o/robot=0/r=%25D0%2596%25D0%25B5%25D0%25BB%25D1%2582%25D1%2583%25D1%2585%25D0%25B8%25D0%25BD/service=intrasearch-people/kps=78408/uid=is1120000000834105/yandexuid=is1120000000834105/reqid=1736513964647383-486734910552747836-saas-searchproxy-stable-vla-16-SAAS-intrasearch-people/raId=93752F98C0FA9623/slots=/how=rlv/*data=url%3Dhttps%3A%2F%2Fstaff.yandex-team.ru%2Fzheltukhina-o"
                ],
                "layer": "people",
                "id": "zheltukhina-o",
                "title": "Ольга Желтухина",
                "staff_id": 390217,
                "uid": "1120000000581197",
                "login": "zheltukhina-o",
                "name": {
                    "first": "Ольга",
                    "last": "Желтухина",
                    "middle": ""
                },
                "is_dismissed": false,
                "affiliation": "external",
                "is_robot": false,
                "is_memorial": false,
                "staff_agreement": false,
                "phone": null,
                "telegram": [
                    "sannyolala"
                ],
                "position": "Внешний консультант",
                "department_name": "Внешние консультанты Подгруппа самозанятых агентов (РФ)",
                "gaps": [],
                "gap": null,
                "cars": [],
                "bicycles": []
            },
            {
                "url": "https://staff.yandex-team.ru/hishouarata",
                "click_urls": [
                    "//clck.yandex.ru/click/dtype=SAAS/p=2/saas_url=https%3A%2F%2Fstaff.yandex-team.ru%2Fhishouarata/robot=0/r=%25D0%2596%25D0%25B5%25D0%25BB%25D1%2582%25D1%2583%25D1%2585%25D0%25B8%25D0%25BD/service=intrasearch-people/kps=78408/uid=is1120000000834105/yandexuid=is1120000000834105/reqid=1736513964647383-486734910552747836-saas-searchproxy-stable-vla-18-SAAS-intrasearch-people/raId=BEFADCEBDF60A2C7/slots=/how=rlv/*data=url%3Dhttps%3A%2F%2Fstaff.yandex-team.ru%2Fhishouarata"
                ],
                "layer": "people",
                "id": "hishouarata",
                "title": "Данила Желтухин",
                "staff_id": 463530,
                "uid": "1120000000764013",
                "login": "hishouarata",
                "name": {
                    "first": "Данила",
                    "last": "Желтухин",
                    "middle": ""
                },
                "is_dismissed": false,
                "affiliation": "external",
                "is_robot": false,
                "is_memorial": false,
                "staff_agreement": true,
                "phone": null,
                "telegram": [
                    "danilaee"
                ],
                "position": "Бригадир",
                "department_name": "Подгруппа вспомогательного персонала СЦ МСК Строгино (Поддержка бизнеса)",
                "gaps": [],
                "gap": null,
                "cars": [],
                "bicycles": []
            },
            {
                "url": "https://staff.yandex-team.ru/alexeyzhelt",
                "click_urls": [
                    "//clck.yandex.ru/click/dtype=SAAS/p=3/saas_url=https%3A%2F%2Fstaff.yandex-team.ru%2Falexeyzhelt/robot=0/r=%25D0%2596%25D0%25B5%25D0%25BB%25D1%2582%25D1%2583%25D1%2585%25D0%25B8%25D0%25BD/service=intrasearch-people/kps=78408/uid=is1120000000834105/yandexuid=is1120000000834105/reqid=1736513964647383-486734910552747836-saas-searchproxy-stable-vla-18-SAAS-intrasearch-people/raId=BEFADCEBDF60A2C7/slots=/how=rlv/*data=url%3Dhttps%3A%2F%2Fstaff.yandex-team.ru%2Falexeyzhelt"
                ],
                "layer": "people",
                "id": "alexeyzhelt",
                "title": "Алексей Желтухин",
                "staff_id": 486172,
                "uid": "1120000000834105",
                "login": "alexeyzhelt",
                "name": {
                    "first": "Алексей",
                    "last": "Желтухин",
                    "middle": ""
                },
                "is_dismissed": true,
                "affiliation": "yandex",
                "is_robot": false,
                "is_memorial": false,
                "staff_agreement": true,
                "phone": null,
                "telegram": [
                    "zheltukhinalexey"
                ],
                "position": "Разработчик",
                "department_name": "Команда автоматизации",
                "gaps": [],
                "gap": {
                    "url": "https://staff.yandex-team.ru/gap/8030662",
                    "color": "#4260c2",
                    "name": "дежурит",
                    "time": "до 5&nbsp;октября",
                    "workflow": "absence",
                    "type": "absence",
                    "date_from": null,
                    "date_to": null
                },
                "cars": [
                    {
                        "number": "O 998 BO 152",
                        "model": "LADA VESTA"
                    }
                ],
                "bicycles": []
            },
            {
                "url": "https://staff.yandex-team.ru/gavrilin",
                "click_urls": [
                    "//clck.yandex.ru/click/dtype=SAAS/p=0/saas_url=https%3A%2F%2Fstaff.yandex-team.ru%2Fgavrilin/robot=0/r=gavrilin/service=intrasearch-people/kps=83933/uid=is1120000000834105/yandexuid=is1120000000834105/reqid=1759845019796341-12788471897239686704-saas-searchproxy-stable-klg-12-SAAS-intrasearch-people/raId=E7A3C856C1C8CD30/slots=1211160,0,3/how=rlv/*data=url%3Dhttps%3A%2F%2Fstaff.yandex-team.ru%2Fgavrilin"
                ],
                "layer": "people",
                "id": "gavrilin",
                "title": "Alexander Gavrilin",
                "staff_id": 3340,
                "uid": "1120000000005034",
                "login": "gavrilin",
                "name": {
                    "first": "Alexander",
                    "last": "Gavrilin",
                    "middle": "Валерьевич"
                },
                "is_dismissed": true,
                "affiliation": "external",
                "is_robot": false,
                "is_memorial": false,
                "staff_agreement": true,
                "phone": null,
                "telegram": [
                    "axegavrilin"
                ],
                "position": "Head of legal practice in the area of software, technology, brand and data transactions",
                "department_name": "External Left HQ",
                "gaps": [],
                "gap": null,
                "cars": [],
                "bicycles": [],
            },
            {
                "title": "Юрий Лысенко",
                "login": "ylysenko78",
                "name": {
                    "first": "Юрий",
                    "last": "Лысенко"
                }
            }
        ],
        "pagination": {
            "page": 0,
            "per_page": 20,
            "pages": 1,
            "count": 8
        }
    }
}

export const peopleResponseMockEn: IntranetSuggestResponse = {
    "people": {
        "result": [
            {
                "url": "https://staff.yandex-team.ru/zheltukhina-o",
                "click_urls": [
                    "//clck.yandex.ru/click/dtype=SAAS/p=0/saas_url=https%3A%2F%2Fstaff.yandex-team.ru%2Fzheltukhina-o/robot=0/r=zheltukhin/service=intrasearch-people/kps=78408/uid=is1120000000834105/yandexuid=is1120000000834105/reqid=1736513924128805-412607189937812205-saas-searchproxy-stable-sas-24-SAAS-intrasearch-people/raId=EB861CBB82251156/slots=/how=rlv/*data=url%3Dhttps%3A%2F%2Fstaff.yandex-team.ru%2Fzheltukhina-o"
                ],
                "layer": "people",
                "id": "zheltukhina-o",
                "title": "Olga Zheltukhina",
                "staff_id": 390217,
                "uid": "1120000000581197",
                "login": "zheltukhina-o",
                "name": {
                    "first": "Olga",
                    "last": "Zheltukhina",
                    "middle": ""
                },
                "is_dismissed": false,
                "affiliation": "external",
                "is_robot": false,
                "is_memorial": false,
                "staff_agreement": false,
                "phone": null,
                "telegram": [
                    "sannyolala"
                ],
                "position": "Внешний консультант",
                "department_name": "External consultants for taxi RU (self employed)",
                "gaps": [],
                "gap": null,
                "cars": [],
                "bicycles": []
            },
            {
                "url": "https://staff.yandex-team.ru/jeltukhin",
                "click_urls": [
                    "//clck.yandex.ru/click/dtype=SAAS/p=1/saas_url=https%3A%2F%2Fstaff.yandex-team.ru%2Fjeltukhin/robot=0/r=zheltukhin/service=intrasearch-people/kps=78408/uid=is1120000000834105/yandexuid=is1120000000834105/reqid=1736513924128805-412607189937812205-saas-searchproxy-stable-sas-24-SAAS-intrasearch-people/raId=EB861CBB82251156/slots=/how=rlv/*data=url%3Dhttps%3A%2F%2Fstaff.yandex-team.ru%2Fjeltukhin"
                ],
                "layer": "people",
                "id": "jeltukhin",
                "title": "Dmitrii Zheltukhin",
                "staff_id": 460300,
                "uid": "1120000000762953",
                "login": "jeltukhin",
                "name": {
                    "first": "Dmitrii",
                    "last": "Zheltukhin",
                    "middle": ""
                },
                "is_dismissed": false,
                "affiliation": "external",
                "is_robot": false,
                "is_memorial": false,
                "staff_agreement": true,
                "phone": null,
                "telegram": [
                    "JeltukhinDmitry"
                ],
                "position": "Специалист",
                "department_name": "Cassiopeia. DQA (Business support team)",
                "gaps": [],
                "gap": null,
                "cars": [],
                "bicycles": []
            },
            {
                "url": "https://staff.yandex-team.ru/hishouarata",
                "click_urls": [
                    "//clck.yandex.ru/click/dtype=SAAS/p=2/saas_url=https%3A%2F%2Fstaff.yandex-team.ru%2Fhishouarata/robot=0/r=zheltukhin/service=intrasearch-people/kps=78408/uid=is1120000000834105/yandexuid=is1120000000834105/reqid=1736513924128805-412607189937812205-saas-searchproxy-stable-sas-24-SAAS-intrasearch-people/raId=EB861CBB82251156/slots=/how=rlv/*data=url%3Dhttps%3A%2F%2Fstaff.yandex-team.ru%2Fhishouarata"
                ],
                "layer": "people",
                "id": "hishouarata",
                "title": "Danila Zheltukhin",
                "staff_id": 463530,
                "uid": "1120000000764013",
                "login": "hishouarata",
                "name": {
                    "first": "Danila",
                    "last": "Zheltukhin",
                    "middle": ""
                },
                "is_dismissed": false,
                "affiliation": "external",
                "is_robot": false,
                "is_memorial": false,
                "staff_agreement": true,
                "phone": null,
                "telegram": [
                    "danilaee"
                ],
                "position": "Бригадир",
                "department_name": "Subgroup of the support staff of the MC Strogino SC (Business support)",
                "gaps": [],
                "gap": null,
                "cars": [],
                "bicycles": []
            },
            {
                "url": "https://staff.yandex-team.ru/alexeyzhelt",
                "click_urls": [
                    "//clck.yandex.ru/click/dtype=SAAS/p=3/saas_url=https%3A%2F%2Fstaff.yandex-team.ru%2Falexeyzhelt/robot=0/r=zheltukhin/service=intrasearch-people/kps=78408/uid=is1120000000834105/yandexuid=is1120000000834105/reqid=1736513924128805-412607189937812205-saas-searchproxy-stable-sas-24-SAAS-intrasearch-people/raId=EB861CBB82251156/slots=/how=rlv/*data=url%3Dhttps%3A%2F%2Fstaff.yandex-team.ru%2Falexeyzhelt"
                ],
                "layer": "people",
                "id": "alexeyzhelt",
                "title": "Aleksei Zheltukhin",
                "staff_id": 486172,
                "uid": "1120000000834105",
                "login": "alexeyzhelt",
                "name": {
                    "first": "Aleksei",
                    "last": "Zheltukhin",
                    "middle": ""
                },
                "is_dismissed": false,
                "affiliation": "yandex",
                "is_robot": false,
                "is_memorial": false,
                "staff_agreement": true,
                "phone": null,
                "telegram": [
                    "zheltukhinalexey"
                ],
                "position": "Разработчик",
                "department_name": "Legal tech team",
                "gaps": [],
                "gap": null,
                "cars": [
                    {
                        "number": "O 998 BO 152",
                        "model": "LADA VESTA"
                    }
                ],
                "bicycles": []
            },
            {
                "title": "Yuri Lysenko",
                "login": "ylysenko78",
                "name": {
                    "first": "Yuri",
                    "last": "Lysenko"
                }
            }
        ],
        "pagination": {
            "page": 0,
            "per_page": 20,
            "pages": 1,
            "count": 8
        }
    }
}
